import React from 'react';

export default function SelectPlan({ paidPlan, setPaidPlan }) {
  return (
    <div className="select-plan">
      <div className="form__label form__label--lg">
        Please select a pricing option
      </div>
      <div className="grid grid--std">
        <div className="grid__col-xs-12">
          <div
            className={`add-event__choice ${paidPlan === '30' ? 'active' : ''}`}
          >
            <label
              className="add-event__checkbox-label"
              onClick={() => {
                setPaidPlan('30');
              }}
            ></label>
            <input
              type="checkbox"
              id="free-event-toggle"
              readOnly
              checked={paidPlan === '30' ? true : false}
            />
            <div className="add-event__checkbox">
              <div className="add-event__checkbox-inner"></div>
            </div>
            <div className="select-plan__text">
              <div className="select-plan__label-top">
                30 Day <span className="dot">&#8226;</span> $25
              </div>
              <div className="select-plan__label-bottom">
                Event feature starts 30 days prior to the{' '}
                <span>Event Start Date</span>
              </div>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div
            className={`add-event__choice ${paidPlan === '60' ? 'active' : ''}`}
          >
            <label
              className="add-event__checkbox-label"
              onClick={() => {
                setPaidPlan('60');
              }}
            ></label>
            <input
              type="checkbox"
              id="paid-event-toggle"
              readOnly
              checked={paidPlan === '60' ? true : false}
            />
            <div className="add-event__checkbox">
              <div className="add-event__checkbox-inner"></div>
            </div>
            <div className="select-plan__text">
              <div className="select-plan__label-top">
                60 Day <span className="dot">&#8226;</span> $50
              </div>
              <div className="select-plan__label-bottom">
                Event feature starts 60 days prior to the{' '}
                <span>Event Start Date</span>
              </div>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div
            className={`add-event__choice ${paidPlan === '90' ? 'active' : ''}`}
          >
            <label
              className="add-event__checkbox-label"
              onClick={() => {
                setPaidPlan('90');
              }}
            ></label>
            <input
              type="checkbox"
              id="paid-event-toggle"
              readOnly
              checked={paidPlan === '90' ? true : false}
            />
            <div className="add-event__checkbox">
              <div className="add-event__checkbox-inner"></div>
            </div>
            <div className="select-plan__text">
              <div className="select-plan__label-top">
                90 Day <span className="dot">&#8226;</span> $75
              </div>
              <div className="select-plan__label-bottom">
                Event feature starts 90 days prior to the{' '}
                <span>Event Start Date</span>
              </div>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div
            className={`add-event__choice ${
              paidPlan === '120' ? 'active' : ''
            }`}
          >
            <label
              className="add-event__checkbox-label"
              onClick={() => {
                setPaidPlan('120');
              }}
            ></label>
            <input
              type="checkbox"
              id="paid-event-toggle"
              readOnly
              checked={paidPlan === '120' ? true : false}
            />
            <div className="add-event__checkbox">
              <div className="add-event__checkbox-inner"></div>
            </div>
            <div className="select-plan__text">
              <div className="select-plan__label-top">
                120 Day <span className="dot">&#8226;</span> $100
              </div>
              <div className="select-plan__label-bottom">
                Event feature starts 120 days prior to the{' '}
                <span>Event Start Date</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
